import React from 'react';
import PropTypes from 'prop-types';
import { useLayout } from '../../layout/context';
import { withChatStatus, statuses } from '../index';
import WebchatInlineCallout from '../inline-callout';
import WebchatButton from '../button';

export const WebchatCta = ({ icon, heading, status, ...rest }) => {
  const { insideSideBar } = useLayout();

  if (!insideSideBar && status !== statuses.ONLINE) {
    return <WebchatInlineCallout icon={icon} status={status} {...rest} />;
  }

  return (
    <WebchatButton
      icon={icon}
      heading={heading}
      status={status}
      insideSideBar={insideSideBar}
      {...rest}
    />
  );
};

WebchatCta.propTypes = {
  icon: PropTypes.string,
  heading: PropTypes.string,
  status: PropTypes.oneOf(Object.values(statuses)),
};

export default withChatStatus(WebchatCta);
